







































































import { Getter } from 'vuex-class';
import { Vue, Component, Watch } from 'vue-property-decorator';
import moment from 'moment';
import { action } from '@/api/reactor/reactions';

@Component({
    reactions: {
      '$sessions/newSession': action(() => {
          var audio = new Audio('/snd/arrive-1.mp3');
          audio.loop = false;
          audio.play(); 
      })
    }
  }
)
export default class Sessions extends Vue {
    get currentTime() {
      var mt = moment();
      mt.add(this.$store.getters['$sessions/currentSessions'].length, 'seconds');
      return mt.format('h:mma');
    }

    etaTime(min: number) {
      var mt = moment();
      mt.add(min, 'minutes');
      return mt.format('h:mma');
    }

    async mounted() {
      await this.$store.dispatch('$destinations/select', this.$route.params.did);
      await this.$store.dispatch('$sessions/startSessionTracking', this.$route.params.did);
    }

    async destroyed() {
      await this.$store.dispatch('$sessions/stopSessionTracking');
    }

    async arrived(session: any) {
      await this.$store.dispatch('$sessions/arrive', session.id);
    }

    async clear(session: any, prompt: boolean) {
      if ((!prompt) || confirm('Remove session for: ' + session.pet)) {
        await this.$store.dispatch('$sessions/clear', {
          sessionId: session.id,
          clear: prompt
        });
      }
    }
}
